export default __webpack_public_path__ + "static/media/PopupIcons_NotesWhite.b15cba00.svg";